

<template>
  <b-overlay :show="showLoader" opacity="0.50" rounded="sm">
    
    <b-card class="principal">
      
      <div class="my-1 d-flex justify-content-between">

        <div class="col-6 d-flex">
          <v-select 
            id="estadorevmult" 
            v-model="estadoAtencionMultiples" 
            :options="estadoAtencionOpts"
            placeholder="Estado de la atención." 
            :reduce="option => option.value" label="text"
            class="col-6"
          />

          <div class="col-5">

            <b-button 
              variant="primary" 
              @click="changeStatusOfSelectedItems" 
            >
              Cambiar Estado
            </b-button>
          </div>
        </div> 
        

        <ReportesAtenciones :downloadFinished="downloadFinished"/>

      </div>

     
      <h5 class="text-right my-1 mx-1">Resultados: {{table.totalRows}}</h5>
      <b-table 
        v-if="!loadingTable && atencionesToShow.length > 0" 
        striped responsive 
        :per-page="table.perPage"
        :items="atencionesToShow" 
        :fields="tableFields" 
        sort-by.sync=""
        sort-desc.sync=false 
        sort-direction="asc"
      >
        <template #cell(diagnosticos)="data">
          {{ data.item.mainDiagnostico ? data.item.mainDiagnostico.diagnostico.descripcion: "No disponible" }}
          {{ data.item.mainDiagnostico.diagnostico ? `${(data.item.mainDiagnostico.diagnostico.codigo)}` :""}}
        </template>

        <template #cell(estadorev)="data">
          <span :style="getEstadoStyle(data.item.estadorev)">
            {{ getEstadoText(data.item.estadorev) }}
          </span>
        </template>
        <template #cell(acciones)="data">
          <div class="d-flex justify-content-end">
            <b-button 
              v-if="hasPermission('auditoria_ver_atencion')" 
              variant="info" 
              size="sm"
              @click="onModalView(data.item.token)">
              <font-awesome-icon icon="magnifying-glass" style="color: white;" />
            </b-button>

            <b-button 
              variant="warning" 
              size="sm"
              @click="onModalUploads(data.item.token)">
              <i class="fa-solid fa-file-arrow-up" title="Subir consentimiento"/>
            </b-button>

            <!-- <b-button 
              v-if="hasPermission('auditoria_editar_atencion')" 
              variant="primary" 
              size="sm"
              @click="editItem(data.item.id)"
            >
              <strong><i class="fas fa-pencil" title="Auditar"/></strong>
            </b-button> -->

            <b-button 
              v-if="hasPermission('auditoria_comentarios_atencion')"
              variant="warning" 
              size="sm" 
              @click="onModalComments(data.item.token)"
            >
              <strong><i class="fas fa-chess-bishop" title="Auditar"/></strong>
            </b-button>

            <b-button 
              v-if="isDigitador || isAuditor"
              size="sm" 
              @click="onModalCommentValidacion(data.item.token)"
              style="position: relative;"
              title="Comentario Validacion"
            >
              <strong>
                <i class="fa-solid fa-check-to-slot" />
              </strong>

              <b-badge 
                style="position: absolute; top: -0.5rem;"
                variant="danger"
                v-if="nComentariosValidacionCurrentDoctor(data.item.comentariosValidacionRevisados) > 0"
              >{{ nComentariosValidacionCurrentDoctor(data.item.comentariosValidacionRevisados) }}</b-badge>
            </b-button>

            <b-button 
              v-if="isDoctor"
              size="sm" 
              @click="onModalCommentValidacionView(data.item.token)"
              variant="warning"
              style="position: relative;"
            >
              <strong>
                <i 
                  class="fa-solid fa-check-to-slot" 
                  title="Comentario Validacion"
                />
              </strong>
            <b-badge 
                style="position: absolute; top: -0.5rem;"
                variant="danger"
                v-if="data.item.comentariosValidacionPorRevisar.length > 0"
              >{{ data.item.comentariosValidacionPorRevisar.length }}
            </b-badge>
            </b-button>
            
            <b-button 
              v-if="isissfa(data.item.idcobertura)"
              size="sm" 
              @click="codigoValidacionIssfa(data.item.token)"
              style="position: relative;"
            >
              <strong>
                <i 
                  class="fa-solid fa-book" 
                  title="codigo Validacion Issfa"
                />
              </strong>
            </b-button>

            <b-button 
              v-if="hasPermission('auditoria_observarcomentarios_atencion')" 
              variant="success"
              size="sm" 
              @click="onModalViewComments(data.item.token)" 
              class="position-relative d-inline"
            >
              <strong>
                <i class="fas fa-eye"></i>
              </strong>
              <!-- <b-badge 
                v-if="totalRegistros[data.index] !== 0" 
                variant="danger"
                class="position-absolute top-0 start-100 translate-middle"
                style="top: -0.5rem;">{{ totalRegistros[data.index] }}
              </b-badge> -->
            </b-button>

          </div>
        </template>

        <template #cell(check)="data">
          <b-form-checkbox v-model="selectedItems" :value="data.item.token"/>
        </template>

        <template #cell(informes)="data">
          
        </template>
      </b-table>


      <div 
        v-if="!atencionesToShow.length && !loadingTable"
        class="text-center"
      >
        <EmptyResults/>
      </div>

      <b-skeleton-wrapper v-if="loadingTable">
        <b-skeleton 
          v-for="i in 15"
          :key="i"
          width="100%" 
          height="50px"
        />
      </b-skeleton-wrapper>

      <b-pagination 
        v-if="atencionesToShow.length > 0" 
        v-model="table.currentPage" 
        :total-rows="table.totalRows"
        :per-page="table.perPage"
        first-number last-number 
        :small="true" 
        class="mb-0" 
        align="center" 
        prev-class="prev-item"
        next-class="next-item" 
        @change="onChangePage"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
      <CodigoIssfa/>
    </b-card>
  </b-overlay>
</template>

<script>
import vSelect from 'vue-select';
import { EmptyResults } from '@/shared/components';
import { comprobarRoles, getUserNameLS } from '@/shared/helpers';
import { ROLES } from '@/shared/constants';
import { mapState } from "vuex";
import { getEstablecimientoLS, getIdDoctorLS } from '@/shared/helpers/dataLocalStorage';
import { atencionMedicaService } from "../../services";
import CodigoIssfa         from '../AtencionValidacionComentario/CodigoIssfa.vue';
import actions from '../../../../assets/utils/utils';
import ReportesAtenciones from './ReportesAtenciones.vue';

export default {
  name: "TableAtenciones",

  components: {
    CodigoIssfa,
    vSelect,
    EmptyResults,
    ReportesAtenciones
  },


  data(){
    return {
      downloadFinished:false,
      idcobertura:null,
      showLoader:false,
      estadoAtencionMultiples:null,
      atencionesToShow:[],

      selectedItems: [],

      loadingTable: false,

      filters:{
        idPaciente     : null,
        establecimiento: null,
        especialidad   : null,
        estadoRevision : null,
        porRevisar     : null,
        idAtencion     : null
      },

      estadoAtencionOpts: [
        { value: '0', text: 'Atendida' },
        { value: '1', text: 'Por revisar' },
        { value: '2', text: 'Revisada' },
        { value: '3', text: 'Concluida' }, 
        { value: '4', text: 'Anulada' },  
        { value: '5', text: 'Auditada' } 
      ],

      table:{
        perPage: 15,
        currentPage: 1,
        sortyBy: null,
        sortDesc: false,
        totalRows: 0
      },

      fieldsTable: [
        { key: 'check',           label: '', thClass: 'text-center' },
        { key: 'establecimiento', label: 'Establecimiento', sortable: true, thClass: 'text-center' },
        { key: 'fechaCita',     label: 'Fecha Atencion', sortable: true, thClass: 'text-center' },
        { key: 'paciente',     label: 'Paciente',       sortable: true, thClass: 'text-center' },
        { key: 'doctor',       label: 'Doctor',         sortable: true, thClass: 'text-center' },
        { key: 'especialidad', label: 'Especialidad',   sortable: true, thClass: 'text-center' },
        { key: 'tipoCobertura', label: 'Cobertura',     sortable: true, thClass: 'text-center' },
        { key: 'diagnosticos', label: 'Diagnostico',    sortable: true, thClass: 'text-center', tdClass: 'text-right' },
        { key: 'estadorev',    label: 'Estado Rev.',    sortable: true, thClass: 'text-center' },
        { key: 'acciones',     label: 'acciones',       sortable: true, thClass: 'text-center', tdClass: 'text-right' },
       
      ],
      currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),

    }
  },

  methods:{


    async loadDataTable() {

      if (
        this.filters &&
        (
          this.filters.excelImc !== '8' 
          && this.filters.excelImc !== '9' 
          && this.filters.excelImc !== '2' 
          && this.filters.excelImc !== '7'
        )
      ) {
        this.loadingTable = true;
      }


      const dataSesion = JSON.parse(localStorage.getItem("detalleusuario"));

      let idDoctor = null;

      if (dataSesion && dataSesion.persona && dataSesion.persona.doctorSet && dataSesion.persona.doctorSet.length > 0) {
        idDoctor = dataSesion.persona.doctorSet[0].id;
      }

      if (this.isAuditor) {
        idDoctor = this.filters.idDoctor;
      }

      const establecimientoLS = getEstablecimientoLS();
      const establecimiento = this.isXima
        ? (this.filters.establecimiento || establecimientoLS?.id || null)
        : (establecimientoLS?.id || null);

      const params = {
        ...this.filters,
        establecimiento: establecimiento,
        page: this.table.currentPage,
        pageSize: this.table.perPage,
        idDoctor: idDoctor,
      };

      const atencionesResponse = await atencionMedicaService.getAllAtenciones(params);

      const { atenciones, total, dataArchivo } = atencionesResponse;

      if (dataArchivo) {
        this.downloadFinished = true;
        let nameReport = 'ReporteImc';

        if (this.filters.excelImc === '8') { nameReport = 'ReporteTiempos'; }
        if (this.filters.excelImc === '2') { nameReport = 'ReporteRevisiones'; }
        if (this.filters.excelImc === '9') { nameReport = 'ReporteSatisfaccion'; }

        actions.cargarArchivos(dataArchivo, `${nameReport}.xlsx`, "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64");
        
        return; // Sale de la función si encuentra dataArchivo
      }

      const atencionesTableMap = atenciones.map(atencion => {

        const cita = atencion.cita || {};
        const paciente = cita.paciente?.persona || {};
        const doctor = cita.doctor?.idPersona || {};
        const fechaCita = `${cita.fechaCita || ''} ${cita.horaCita || ''}`.trim();
        const cobertura    = cita.cobSeleccionada?.descripcion;
        const idcobertura    = cita.cobSeleccionada?.id;
        const seguroString = cita.detallescitaSet?.[0]?.detailsSeguro;
        const codigoSeguro = seguroString ? JSON.parse(seguroString)?.seguroSalud?.code : '';
        const coberturaSeguro = `${cobertura || ''} ${codigoSeguro ? `(${codigoSeguro})` : ''}`.trim();
        const diagnosticos = atencion.diaganamSet || [];
        const comentariosValidacion = atencion.comentariovalidacionatencionSet || [];

        return {
          id              : atencion.id || '',
          token           : atencion.token || '',
          fechaing        : new Date(atencion.fechaCreacion).toLocaleString("pt-BR") || '',
          fechaCita       : fechaCita || '',
          establecimiento : cita.establecimiento?.Descripcion || '',
          paciente        : `${paciente.identificacion || ''} - ${paciente.primerNombre || ''} ${paciente.segundoNombre || ''} ${paciente.primerApellido || ''} ${paciente.segundoApellido || ''}`.trim(),
          doctor          : `${doctor.primerNombre || ''} ${doctor.segundoNombre || ''} ${doctor.primerApellido || ''} ${doctor.segundoApellido || ''}`.trim(),
          visita          : atencion.tipoVisita ? atencion.tipoVisita.descripcion : '',
          especialidad    : cita.doctor?.especialidad ? cita.doctor.especialidad.descripcion : '',
          estadorev       : atencion.estadoRev || '',
          idcobertura     : idcobertura || 0,
          diagnosticos    : diagnosticos,
          mainDiagnostico : diagnosticos.filter(d => d.esprincipal === '1')[0] || '',
          tipoCobertura   : coberturaSeguro,
          comentariosValidacion: comentariosValidacion,
          comentariosValidacionRevisados: comentariosValidacion.filter(c => c.estadoComentario === '2'),
          comentariosValidacionPorRevisar: comentariosValidacion.filter(c => c.estadoComentario === '1')
        };
      });

      if (this.filters &&   (
        this.filters.excelImc !== '8' 
        && this.filters.excelImc !== '9' 
        && this.filters.excelImc !== '2' 
        && this.filters.excelImc !== '7'
      )) {
        this.table.totalRows = total;
        this.atencionesToShow = atencionesTableMap;
      }

      this.loadingTable = false;
    },


    async changeStatusOfSelectedItems(){
      
      if(!this.selectedItems.length) {
        this.$swal('Error', 'No se ha seleccionado ningun item', 'error');
        return;
      }

      if(!this.estadoAtencionMultiples) {
        this.$swal('Error', 'No se ha seleccionado ningun estado', 'error');
        return;
      }

      const promises = this.selectedItems.map(
        item => atencionMedicaService.updateByToken(item, { estadoRevision: this.estadoAtencionMultiples })
      );

      const responses = await Promise.all(promises);
      
      if(!responses.length) {
        this.$swal('Error', 'No se ha podido actualizar ningun estado', 'error');
        return;
      }

      await this.$swal('Éxito', 'Todos los estados han sido actualizados correctamente', 'success');
      
      this.selectedItems = [];
      this.loadDataTable();
    },


    onChangePage(page) {
      this.table.currentPage = page;
      this.loadDataTable();
    },

    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem('permisos');
      return permisosUsuario.indexOf(permission) !== -1;
    },

    getEstadoText(value) {
      const state = this.estadoAtencionOpts.find( s => s.value === value);
      return state ? state.text : 'Sin Estado';
    },

    codigoValidacionIssfa(tokenatencion){
      this.navigateToQuery("code", tokenatencion);
    },
    getEstadoStyle(value) {
      return {
        padding: '5px 10px', 
        borderRadius: '15px',
        backgroundColor: (value === '1') ? 'red' : '#68c568',
        color: 'white',
        display: 'inline-block',
      };
      
    },

    async viewItem(idAdm) {
      this.idAtencion = idAdm;
      await this.fetchAteMedByid(idAdm, 'v');
    },


    onModalView( tokenAtencion ){
      this.navigateToQuery('view_atencion', tokenAtencion);
    },


    onModalUploads( tokenAtencion ){
      this.navigateToQuery('uploads_atencion', tokenAtencion);
    },

    onModalComments( tokenAtencion ){
      this.$router.push({ name: 'atenciones-medicas', query: { comments: tokenAtencion } })
    },

    onModalViewComments( tokenAtencion ){
      this.$router.push({ name: 'atenciones-medicas', query: { vcomments: tokenAtencion } });
    },

    onModalCommentValidacion( tokenAtencion ){
      this.navigateToQuery('validator', tokenAtencion);
    },

    onModalCommentValidacionView( tokenAtencion ){
      this.$router.push({ name: 'atenciones-medicas', query: { vvalidator: tokenAtencion } });
    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },
    isissfa(idcobertura){
      let dd = false;
      if(idcobertura && idcobertura === '3') 
        dd = true; 
      return dd;
    },
    nComentariosValidacionCurrentDoctor( comentarios ){
      const userName = getUserNameLS();
      if (comentarios && comentarios.length === 0) return 0;
      const total = comentarios.filter( c => c.usuarioCreador.username === userName ).length
      return total;
    },


    syncFilters(){
      const newValue = this.stFilterAtenciones;

      this.filters = {
        establecimiento : newValue.establecimiento || null,
        especialidad    : newValue.especialidad    || null,
        estadoRevision  : newValue.estadoRevision  || null,
        idPaciente      : newValue.paciente?.value || null,
        idDoctor        : newValue.doctor?.value   || null,
        fechaDesde      : newValue.fechaDesde      || null,
        fechaHasta      : newValue.fechaHasta      || null,
        excelImc        : newValue.excelImc        || null,
        // sinDiagnosticos : newValue.sinDiagnosticos ,
        porRevisar      : newValue.porRevisar ? '1' : '0',
        idAtencion      : newValue.idAtencion      || null,

        tipoCobertura   : newValue.cobertura       || null,
        segsalud        : newValue.segsalud        || null,
        observaciones   : newValue.observaciones   || null
      };

      this.table.currentPage = 1;
    }
  },

  computed: {
    ...mapState({
      // stAtencionesFilters  : state => state.atencionMedica.tableFilters,
      // stFilterObservaciones: state => state.atencionMedica.observacionesFilters
      stFilterAtenciones  : state => state.generals.filterAtenciones,
      stFilterObservaciones: state => state.atencionMedica.observacionesFilters
    }),
    isXima() {
      return this.currentEstablecimiento?.uniCodigo === '36451';
    },
    tableFields() {
      if (this.isXima) return this.fieldsTable;
      return this.fieldsTable.filter(field => field.key !== 'establecimiento');
    },
    isDigitador() {
      return comprobarRoles( [ROLES.DIGITADOR, ROLES.JEFE_VALIDACIONES] );
    },

    isAuditor() {
      return comprobarRoles( [ROLES.AUDITOR, ROLES.JEFE_AUDITOR] );
    },

    isDoctor(){
      return comprobarRoles( ROLES.DOCTOR );
    },
    
  },



  watch:{


    stFilterAtenciones: {
      
      deep: true,
      handler(newValue){
        this.syncFilters();
        this.loadDataTable();

        console.log('filters', newValue);
      }
    },

    downloadFinished(newVal){
      if(newVal === true){
        setTimeout(() => {
          this.downloadFinished = false;
        }, 1000);
      }
    }



    // filters: {
    //   deep: true,
    //   handler(){
    //     this.loadDataTable();
    //   }
    // },

  }

}
</script>
